import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function darkenHexColor(hex: string, percent: number): string {
  const num = parseInt(hex.replace('#', ''), 16);
  const amt = Math.round(2.55 * percent);
  const R = (num >> 16) - amt;
  const G = ((num >> 8) & 0x00ff) - amt;
  const B = (num & 0x0000ff) - amt;
  const clamp = (v: number) => Math.min(255, Math.max(0, v));
  return (
    '#' +
    [R, G, B]
      .map(clamp)
      .map((v) => v.toString(16).padStart(2, '0'))
      .join('')
  );
}
